export default __webpack_public_path__ + "static/media/down-solid.d027d662.svg";